// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2Fg3X","rowsWrapper":"style_rowsWrapper__eOGDK","rowWrapper":"style_rowWrapper__1VyJ0","text":"style_text__3vGGj"};